import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { KeycloakService } from '../keycloak/keycloak.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // traditional login stores a session token; SSO users fall back to the Keycloak JWT
        const loginToken = sessionStorage.getItem('LoginToken');
        if (loginToken) {
            return next.handle(request.clone({ setHeaders: { Authorization: loginToken } }));
        }
        if (KeycloakService.keycloakAuth && KeycloakService.keycloakAuth.authenticated
                && KeycloakService.keycloakAuth.token) {
            // refresh if expiring within 5 seconds before attaching to the request
            const refreshed = new Promise<string>((resolve, reject) => {
                KeycloakService.keycloakAuth.updateToken(5)
                    .success(() => resolve(KeycloakService.keycloakAuth.token as string))
                    .error(() => reject());
            });
            return from(refreshed).pipe(
                switchMap(token => next.handle(request.clone({ setHeaders: { Authorization: 'Bearer ' + token } }))),
                catchError(() => next.handle(request))
            );
        }
        return next.handle(request);
    }
}
